<template>
  <div class="podcast-section-font">
    <div v-if="loading" class="text-gray-600">
      Loading...
    </div>

    <div v-else>
      <v-style
        type="text/css"
        scoped
        v-for="(font, index) in choices"
        :key="index"
      >
        <template v-if="font.google">@import url({{ font.url }});</template>
        <template v-else>
          @font-face { font-family: '{{ font.family }}'; font-weight: 400; src:
          local('{{ font.family }}'), url('{{ font.url }}') format('{{
            font.format
          }}'); font-display: swap; }
        </template>
      </v-style>
      <FormSection class="col-1/2">
        <FormRow
          label="Scegli il font per i totoli"
          forId="select-font-title"
          name="font"
          rules="required"
          mode="aggressive"
        >
          <v-select
            :options="choices"
            placeholder="Seleziona"
            :searchable="false"
            :clearable="false"
            v-model="modelData.fontDisplay"
            :reduce="font => font.slug"
            id="select-font-title"
          >
            <template #option="{ family, label }">
              <span :style="{ 'font-family': family, 'font-size': '16px' }">{{
                label
              }}</span>
            </template>
          </v-select>
        </FormRow>
      </FormSection>

      <FormSection class="col-1/2">
        <FormRow
          label="Scegli il font per il testo"
          forId="select-font-body"
          name="font"
          rules="required"
          mode="aggressive"
        >
          <v-select
            :options="choices"
            placeholder="Seleziona"
            :searchable="false"
            :clearable="false"
            v-model="modelData.fontBody"
            :reduce="font => font.slug"
            id="select-font-body"
          >
            <template #option="{ family, label }">
              <span :style="{ 'font-family': family, 'font-size': '16px' }">{{
                label
              }}</span>
            </template>
          </v-select>
        </FormRow>
      </FormSection>
    </div>
  </div>
</template>

<script>
import PodcastSectionBase from './PodcastSectionBase'

import GET_PODCAST_FONT from '@/graphql/GetPodcastFont.gql'
import UPDATE_PODCAST_FONT from '@/graphql/UpdatePodcastFont.gql'

export default {
  extends: PodcastSectionBase,

  section: {
    query() {
      return {
        query: GET_PODCAST_FONT,
        variables: { podcastId: this.id },
      }
    },
    mutation() {
      return this.$apollo.mutate({
        mutation: UPDATE_PODCAST_FONT,
        variables: {
          id: this.id,
          fontBody: this.modelData.fontBody,
          fontDisplay: this.modelData.fontDisplay,
        },
      })
    },
    model: {
      fontDisplay: null,
      fontBody: null,
    },
    saveModel(data) {
      if (data.settingsByKey) {
        this.choices = JSON.parse(data.settingsByKey.value).map(font => ({
          url: font.url,
          slug: font.slug,
          label: font.name,
          family: font.family,
          format: font.format,
          google: font.google,
        }))
      }

      const model = { ...data.findPodcastByID.settings }
      if (model.font) {
        if (!model.fontBody) {
          model.fontBody = model.font
        }

        if (!model.fontDisplay) {
          model.fontDisplay = model.font
        }
      }

      delete model.font

      return model
    },
  },

  data() {
    return {
      choices: [],
    }
  },
}
</script>

<style lang="scss" scoped>
/deep/ {
  .v-select {
    @apply inline-block min-w-50;
  }
}
</style>
